import { ResultModel } from './resultmodel';

export class DataResult<T> extends ResultModel {
    Data: T;
}
